import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const AttachmentCircleArrowLeftIcon = createIcon({
  displayName: 'AttachmentCircleArrowLeftIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g xmlns="http://www.w3.org/2000/svg" fill="none">
        <path d="M24 24h-24v-24h24Z" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16 21.5l-2-2 2-2"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11.0644 12.4356l2.93918e-07 2.56603e-07c1.07246.936301 2.67172.936301 3.74418-5.13207e-07l.9356-.93559v0l6.52761e-08-6.66706e-08c1.023-1.04486 1.00529-2.72119-.0395703-3.74419 -1.02928-1.00775-2.67535-1.00775-3.70463 5.62612e-06"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.9356 10.5644l-9.79458e-08-8.5511e-08c-1.07246-.936301-2.67172-.936301-3.74418 1.71022e-07l-.9356.9356v0l1.7439e-08-1.78161e-08c-1.02287 1.04499-1.00494 2.72132.0400464 3.74418 1.02922 1.00743 2.67493 1.00743 3.70414-5.0024e-06"
        />
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M20 19.5h-6" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20.0583 15.5036l5.31936e-08-1.07069e-07c2.21106-4.45047.39566-9.85072-4.05481-12.0618 -4.45047-2.21106-9.85072-.39566-12.0618 4.05481 -2.21106 4.45047-.39566 9.85072 4.05481 12.0618 .63799.316963 1.31136.557039 2.00598.715186"
        />
      </g>
    </>
  ),
})

const AttachmentCircleArrowLeft: FC<IconProps> = (props) => {
  return <CustomIcon as={AttachmentCircleArrowLeftIcon} {...props} />
}

export default memo(AttachmentCircleArrowLeft)
